import { render, staticRenderFns } from "./MateriDetail.vue?vue&type=template&id=ebaa5d34&scoped=true"
import script from "./MateriDetail.vue?vue&type=script&lang=js"
export * from "./MateriDetail.vue?vue&type=script&lang=js"
import style0 from "./MateriDetail.vue?vue&type=style&index=0&id=ebaa5d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebaa5d34",
  null
  
)

export default component.exports